import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toggleLoading } from "../../LoadingSlice";
import { toast } from "react-toastify";

export interface NotificationUserData {
    warehouse_id: number;
    first_name: string;
    last_name: string;
    email: string;
    designation: string;
    // notification_type: string;
    user_hierarchy_level: number;
    status: string;
    action: string;
}

interface UsersState {
    notificationusers: {
        load: boolean;
        data: Array<NotificationUserData>;
        error: Array<NotificationUserData>;
    };
    notificationuserData?: NotificationUserData;
}
const initialState = {
    notificationusers: {
        load: false,
        data: [],
        error: [],
    },
    notificationuserData: {
        warehouse_id: 0,
        first_name: "",
        last_name: "",
        email: "",
        designation: "",
        // notification_type: "",
        user_hierarchy_level: 0,
        status: "1",
        action: ""
    },
} as UsersState;

export const notificationusersSlice = createSlice({
    name: "notificationusers",
    initialState,
    reducers: {
        resetNotificationUserData: (state: UsersState) => {
            state.notificationuserData = initialState.notificationuserData;
        },
        updateNotificationUserData: (state: UsersState, action: { payload: NotificationUserData }) => {
            state.notificationuserData = action.payload;
        },
        addNotificationUserError: (state: UsersState, action: any) => {
            state.notificationusers.error = action.payload;
        },
        failNotificationUserError: (state, action) => {
            state.notificationusers.error = action.payload;
        },
    },
    extraReducers: (builder: any) => {
        builder
            .addCase(fetchNotificationUsers.pending, (state: UsersState) => {
                state.notificationusers.load = true;
            })
            .addCase(fetchNotificationUsers.fulfilled, (state: UsersState, action: any) => {
                state.notificationusers.data = action.payload;
                state.notificationusers.load = false;
            })
            .addCase(fetchNotificationUsers.rejected, (state: UsersState, action: any) => {
                state.notificationusers.load = false;
            });
    },
});
export const { updateNotificationUserData, resetNotificationUserData, addNotificationUserError, failNotificationUserError } = notificationusersSlice.actions;
export default notificationusersSlice.reducer;

export const fetchNotificationUsers = createAsyncThunk(
    "notificationusers/fetchNotificationUsers",
    async (param: any, thunkAPI) => {
        try {
            const { data } = await DataServer.get("api/GetNotificationUsers?warehouse_id=" + param.apiParam.warehouse_id + "&search=" + param.apiParam.search );
            return data.data;
        } catch (error) {
        }
    }
);

export const addNotificationUser = createAsyncThunk(
    "notificationusers/addNotificationUser",
    async (param: { apiParam: any, navigation: any }, thunkAPI) => {
        try {
            thunkAPI.dispatch(toggleLoading());
            const { data } = await DataServer.post(
                "api/PostAddNotificationUser",
                param.apiParam
            );

            thunkAPI.dispatch(toggleLoading());
            
            if(data.message == "User successfully added!"){
                toast.success(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});
            } else {
                toast.warning(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});
            }

            const handleonConfirm = () => {
                param.navigation("/escalation-matrix", {state: {from: "users"}});
            };
            return data.data;
        } catch (error) {
            thunkAPI.dispatch(toggleLoading());
            thunkAPI.dispatch(failNotificationUserError(error));
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const deleteNotificationUser = createAsyncThunk(
    "notificationusers/deleteNotificationUser",
    async (param: { apiParam: any, navigation: any }, thunkAPI) => {
        try {
            thunkAPI.dispatch(toggleLoading());
            const { data } = await DataServer.post("api/deleteNotificationUsers", param.apiParam);

            thunkAPI.dispatch(toggleLoading());
                        
            toast.success(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});

            const handleonConfirm = () => {
                thunkAPI.dispatch(fetchNotificationUsers({ apiParam: { warehouse_id: param.apiParam.warehouse_id, search: param.apiParam.search } }));
            };
            return data.data;
        } catch (error) {
            thunkAPI.dispatch(toggleLoading());
        }
    }
);
